import React from 'react';
import PropTypes from 'prop-types';
import { TableRow, TableCell } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import CheckAllIcon from '@mui/icons-material/CheckBox';
import ClearAllIcon from '@mui/icons-material/IndeterminateCheckBox';

import TableSortHeaderCell from 'src/components/Tables/TableSortHeaderCell';
import * as types from 'src/types';

export default function PayerClaimsHeader({
  criteria: { claimsOrderBy, claimsOrderDesc },
  updateCriteria,
  isSelectable,
  selectedCount,
  selectAll,
  selectNone,
}) {
  const order = claimsOrderDesc ? 'desc' : 'asc';
  return (
    <TableRow>
      {isSelectable && (
        <TableCell sx={{ padding: '0 0 0 1px' }}>
          {selectedCount === 0 ? (
            <IconButton onClick={selectAll} size="large">
              <CheckAllIcon color="primary" sx={{ transform: 'scale(1.3)' }} />
            </IconButton>
          ) : (
            <IconButton onClick={selectNone} size="large">
              <ClearAllIcon color="primary" sx={{ transform: 'scale(1.4)' }} />
            </IconButton>
          )}
        </TableCell>
      )}
      <TableSortHeaderCell
        keyName="oldestUnpaidDueDate"
        title="Gjalddagi"
        order={order}
        orderBy={claimsOrderBy}
        orderHandler="claimsOrderDesc"
        orderByHandler="claimsOrderBy"
        tooltipTitle="Raða eftir gjalddaga"
        updateCriteria={updateCriteria}
        width="13.25%"
      />
      <TableSortHeaderCell
        keyName="oldestUnpaidDueDate"
        title="Staða í innheimtu"
        order={order}
        orderBy={claimsOrderBy}
        orderHandler="claimsOrderDesc"
        orderByHandler="claimsOrderBy"
        tooltipTitle="Raða eftir gjalddaga"
        updateCriteria={updateCriteria}
        width="20%"
      />
      <TableSortHeaderCell
        keyName="claimId"
        title="Málanúmer"
        order={order}
        orderBy={claimsOrderBy}
        orderHandler="claimsOrderDesc"
        orderByHandler="claimsOrderBy"
        tooltipTitle="Raða eftir málanúmeri"
        updateCriteria={updateCriteria}
        width="10%"
      />
      <TableSortHeaderCell title="" />
      <TableSortHeaderCell
        keyName="totalRemaining"
        title="Til greiðslu"
        order={order}
        orderBy={claimsOrderBy}
        orderHandler="claimsOrderDesc"
        orderByHandler="claimsOrderBy"
        tooltipTitle="Raða eftir stöðu greiðanda"
        updateCriteria={updateCriteria}
        align="right"
      />
    </TableRow>
  );
}

PayerClaimsHeader.propTypes = {
  criteria: types.criteria.isRequired,
  updateCriteria: PropTypes.func.isRequired,
  isSelectable: PropTypes.bool.isRequired,
  selectedCount: PropTypes.number.isRequired,
  selectAll: PropTypes.func.isRequired,
  selectNone: PropTypes.func.isRequired,
};
